import * as React from 'react';
import styled from 'styled-components';

import { useLinks, useModalSettingsContext, usePostMessageContext, useStrings } from 'src/providers';

interface ITermsLinkProps {
  position: string;
}

const StyledTermsLink = styled.div`
  display: flex;
  justify-content: center;
  font-size: 12px;
  line-height: 16px;

  padding-bottom: 24px;

  @media (min-height: 700px) {
    padding-bottom: 0;
  }

  &.main-tab__tncs--over {
    margin-bottom: 32px;
  }

  @media (max-width: 550px) and (min-height: 720px) {
    &.main-tab__tncs--under {
      position: absolute;
      bottom: 32px;
      left: 24px;
      right: 24px;
    }
  }

  .main-tab__tncs__links {
    text-align: center;
    color: var(--dark-gray);
    white-space: pre-wrap;

    &:hover {
      color: var(--black);
    }
  }

  .main-tab__tncs__links span {
    display: block;
    font-weight: 500;
  }
`;

const TermsLink = (props: ITermsLinkProps) => {
  const { position } = props;
  const links = useLinks();
  const { modalType } = useModalSettingsContext();
  const { postMessage } = usePostMessageContext();
  const { termsAndConditionsLink } = useStrings();

  return (
    <StyledTermsLink className={`main-tab__tncs main-tab__tncs--${position}`}>
      <a
        href={links.terms}
        target='_blank'
        className='main-tab__tncs__links'
        onClick={() => { postMessage('seeTermsAndConditions', { ctaType: 'modal', modalType }); }}
        rel='noreferrer'
        data-test='bullets-under'
      >
        {termsAndConditionsLink}
      </a>
    </StyledTermsLink>
  );
};

export default TermsLink;
